<template>
  <div>
    <v-row
        cols="12" class="ma-0 pa-0"
    >
      <v-col class="ma-0 pa-1" cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-form
            class="border pa-2"
            ref="form"
            v-model="valid"
            lazy-validation
        >
          <h3 class="mb-4">Buscador imprimax</h3>
          <div>
            <v-text-field
                outlined
                filled
                label="Insira o CEP"
                v-mask="'#####-###'"
                dense
                v-model="cep"
                style="border-radius: 30px"
                :rules="[rules.required, rules.minCep]"
            ></v-text-field>
          </div>

          <div
              v-for="(product, index) in products"
              :key="`${index}`"
              class="pt-3"
          >
            <div>
              <label>Produto {{ index + 1 }}</label>
              <v-autocomplete
                  v-model="product.productId"
                  clearable
                  :items="productsSelect"
                  item-text="productName"
                  item-value="productId"
                  append-icon="mdi-chevron-down"
                  outlined
                  placeholder="Insira o nome do produto"
                  dense
                  style="border-radius: 30px"
                  :rules="[rules.required]"
              >
              </v-autocomplete>
            </div>

            <div>
              <label>Selecione a largura</label>
              <div class="d-flex flex-wrap">
                <a
                    v-for="item in attributeGroups"
                    :key="item.name"
                    class="ma-1 sku"
                    @click="setSku(products, index, item.name)"
                    :style="product.sku == item.name ? 'background: #bc0000!important; color: #FFFFFF!important;' : 'background: transparent!important;color: #000000DE!important;'"
                >
                  {{ item.name }}
                </a>
              </div>
            </div>

            <div class="mt-5">
              <label>Quantidade</label>
              <v-text-field
                  type="number"
                  outlined
                  filled
                  placeholder="Insira a quantidade em metros"
                  v-mask="'#####-###'"
                  dense
                  v-model="product.amount"
                  style="border-radius: 30px"
                  :rules="[rules.required]"
              ></v-text-field>
            </div>

            <div v-if="index > 0" class="mb-3">
              <v-btn
                  elevation="0"
                  color="transparent"
                  class="mb-0 ml-5 pb-0 btn-delete-product"
                  @click="deleteProduct(index)"
                  width="120"
              >
                <div class="d-flex align-center justify-start">
                  <v-icon size="25px" color="#bc0000">
                    mdi-alpha-x-circle
                  </v-icon>
                  <span class="ml-1" style="color: #000000">Excluir produto</span>
                </div>
              </v-btn>
            </div>

            <v-divider></v-divider>
          </div>

          <div>
            <v-btn
                elevation="0"
                color="transparent"
                class="mb-0 pb-0 ml-5 btn-add-product"
                @click="addProduct()"
                width="180"
            >
              <div class="d-flex align-center justify-start">
                <v-icon size="25px" color="#bc0000">
                  mdi-plus-circle
                </v-icon>
                <span class="ml-1" style="color: #000000">Adicionar outro produto</span>
              </div>
            </v-btn>
          </div>

          <div>
            <v-switch
                color="#bc0000"
                v-model="allProductsForResale"
                inset
                label="Restringir busca de produtos somente a revendas que tenham todos os produtos buscados. (essa função não habilita o modo multivendas)."
            ></v-switch>
          </div>

          <div>
            <v-btn
                @click="search()"
                width="100%"
                class="btn-search"
                elevation="1"
            >
              Buscar estoque
            </v-btn>
          </div>
        </v-form>

      </v-col>
      <v-col class="ma-0 pa-1" cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <div class="border pa-2">
          <div class=" ">
            <h3 class="mb-4">Buscador imprimax</h3>
            <v-select
                v-model="filterBy"
                @change="search()"
                style="border-radius: 30px;  "
                :items="items"
                outlined
                dense
                :disabled="!resales || resales.length <= 0"
                item-text="text"
                item-value="value"
                placeholder="Filtrar por"
            >
            </v-select>
          </div>

          <v-card v-if="resales && resales.length > 0" elevation="0" class="mt-0">
            <ul class="resales">
              <li
                  v-for="(resale, index) in resales"
                  :key="resale.resale.id"
                  class=" pa-2"
              >
                <div class="d-flex justify-space-between mb-2">
                  <div class="d-flex">
                    <div class="km pa-1 px-2">
                      {{ resale.distance.toFixed(2) }} Km <br/>
                      de voce
                    </div>

                    <div class="resale   px-2">
                      <p class="mb-1 resaleName"><strong>{{ resale.resale.nameFantasy }}</strong></p>
                      <v-divider></v-divider>
                      <p v-if="resale.allProducts">Contém todos itens <br/></p>
                      <div v-else>
                        <p class="mb-1">Contém os seguintes itens:</p>
                        <p
                            class="productName"
                            v-for="product in resale.products"
                            :key="`${resale.resale.id}${product.productId}`"
                        >
                          {{ product.productName }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="contact float-right">
                    <v-btn
                        v-if="resale && resale.resale && resale.resale.phoneNumber && resale.resale.phoneNumber.length > 0"
                        class="mx-2 icon_whatsapp mb-1"
                        :href="`https://api.whatsapp.com/send?1=pt_BR&phone=55${resale.resale.phoneNumber.replace(/\D/g, '')}`"
                        target="_blank"
                        icon
                    >
                      <v-icon color="#25d366" size="35px">mdi-whatsapp</v-icon>
                    </v-btn>

                    <v-btn
                        v-if="resale && resale.resale && resale.resale.phoneNumber2 && resale.resale.phoneNumber2.length > 0"
                        class="mx-2 icon_whatsapp mb-1"
                        :href="`tel:${resale.resale.phoneNumber2.replace(/\D/g, '')}`"
                        target="_blank"
                        icon
                    >
                      <v-icon color="#000000" size="35px">mdi-phone-in-talk-outline</v-icon>
                    </v-btn>
                  </div>
                </div>
                <div>
                  <p><strong>Endereço:</strong>{{resale.resale.addressName}}, {{resale.resale.neighborhood}}, {{resale.resale.addressNumber}}, {{resale.resale.city}} - {{resale.resale.state}}</p>
                </div>
                <iframe
                    :id="resale.resale.id"
                    :src="`https://www.google.com/maps?q=${resale.resale.latitude},${resale.resale.longitude}&z=16&output=embed`"
                    class="google-maps"
                    width="100%"
                    style="width: 100%!important;"
                    height="300"
                    loading="lazy"
                    allowfullscreen
                ></iframe>
                <v-divider
                    v-if="index < resales.length - 1"
                    :key="index"
                ></v-divider>
              </li>
            </ul>
          </v-card>

          <v-card elevation="0" color="transparent" class="mt-0" v-else-if="filter && filter.filterBy && (!resales || resales.length <= 0)">
            <p class="text-center">Nenhuma revenda possui estoque disponível.</p>
          </v-card>
        </div>

      </v-col>
    </v-row>
  </div>
</template>

<script>

import Vue from "vue";
import ApiService from "../../services/ApiService";
import axios from "axios";

export default {
  name: "InventoryResearchForResale",

  props: {},
  data() {
    return {
      apiService: new ApiService(),
      products: [
        {
          sku: null,
          productId: null,
          amount: null
        }
      ],
      rules: {
        required: (value) => !!value || "Campo requerido.",
        minCep: (value) => value.length >= 9 || "CEP invalido.",
      },
      valid: true,
      allProductsForResale: false,
      cep: '',
      fullAddress: null,
      latitude: null,
      longitude: null,
      attributeGroups: [],
      productsSelect: [],
      resales: [],
      filterBy: 1,
      filter: Object,
      items: [
        {
          text: 'Ordenar as revendas pela distância, da menor para a maior',
          value: 1,
        },
        {
          text: 'Ordenar as revendas pela distância, da maior para a menor',
          value: 2,
        },
        {
          text: 'Ordenar as revendas revendas que possuem todos os produtos',
          value: 3,
        },
        {
          text: 'Ordenar as revendas revendas que não possuem todos os produtos',
          value: 4,
        },
      ],
    }
  },
  async mounted() {
    await this.getAttributesGroup()
    await this.getProdutos()
  },
  computed: {},
  methods: {
    setSku(products, index, sku) {
      const product = products[index].sku == sku
      if (product) {
        products[index].sku = null
        return
      }
      products[index].sku = sku
    },

    addProduct() {
      this.products.push({
        cep: '',
        sku: null,
        amount: null
      },)
    },

    deleteProduct(index) {
      this.products.splice(index, 1)
    },

    async getAttributesGroup() {
      const regex = /\d/;
      await this.apiService
          .get(`attributesgroup/listGroupItems`)
          .then((response) => {
            this.attributeGroups = [...new Map(response.map(item => [item['name'], item])).values()].filter((x) => (regex.test(x.name)));
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "",
              message: "Não foi possível lista os tamanhos!",
              trace: null,
            });
            this.loading = false;
          });
    },

    async search() {
      if (!this.$refs.form.validate()) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Preencha todos os campos corretamente",
          trace: null,
        });
        return
      }
      for (const product of this.products) {
        if(!product.sku){
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Selecione a largura de todos do produtos!",
            trace: null,
          });
          return
        }
      }
      const {cep, latitude, longitude} = this.filter

      if (!cep || (cep && cep != this.cep.replace(/[^\d]/g, '')) || !latitude || !longitude) {
        this.fullAddress = await this.searchCEP()
        if (!this.fullAddress || !this.fullAddress.uf) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "O Cep informado não foi encontrado.",
            trace: null,
          });
          return
        }
        await this.getLocation()
      }
      const body = {
        products: this.products,
        allProductsForResale: this.allProductsForResale,
        cep: this.cep.replace(/[^\d]/g, ''),
        latitude: this.latitude,
        longitude: this.longitude,
        filterBy: this.filterBy,
      }
      const {content} = await this.apiService.post(`product/stock`, body)
      const {resalesDistance, filter} = content
      this.filter = filter
      this.resales = resalesDistance
    },

    async getProdutos() {
      const {content} = await this.apiService.get(`product/active`)
      this.productsSelect = content
    },
    async searchCEP() {
      try {
        let cepAddress = null;
        if (/^[0-9]{5}-[0-9]{3}$/.test(this.cep)) {
          this.location = {};
          let response = await this.apiService.get(`user/postalcode?cep=${this.cep}`)
          response = JSON.parse(response)
          if (response.uf) {
            cepAddress = response
          }
        }
        return cepAddress
      } catch (e) {

      }
    },

    async getLocation() {
      await this.apiService
          .post("Address/geocode", this.fullAddress)
          .then((response) => {
            const { content } = response || {};
            const { results } = content || {};
            const [{ geometry }] = results || [];
            const { location } = geometry || {};
            const { lat, lng } = location || {};
            this.latitude = parseFloat(lat)
            this.longitude = parseFloat(lng)
          })
          .catch((erro) => {
          });
    },
  }
};
</script>
<style scoped>
.border {
  border: 1px solid #000000;
  border-radius: 10px;
}

.sku {
  border: 2px solid #bc0000;
  border-radius: 45px !important;
  font-weight: 400;
  cursor: pointer;
  text-transform: none;
  font-size: 14px !important;
  padding: 5px !important;
}

.btn-add-product {
  text-transform: none;
  font-size: 15px !important;
}

.btn-delete-product {
  margin-top: -24px;
  text-transform: none;
  font-size: 15px !important;
}

.btn-search {
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #BC0000 !important;
  font-size: 16px !important;
  text-transform: none;
}

.resales {
  list-style: none;
  padding: 0;
  margin: 0;

  .km {
    border: 1px solid #bc0000;
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    max-height: max-content;
  }

  .resale {
    font-weight: 400;
    font-size: 14px;
  }

  .resaleName {
    font-size: 13px;
  }

  .productName {
    font-size: 13px;
  }

  .icon_whatsapp:hover {
    transform: scale(1.2);
  }
}
</style>
